<template>
  <div>
    <h2 class="title" v-if="title">{{ title }}</h2>
    <div class="columns">
      <!-- <b-select v-model="perPage" :disabled="!isPaginated" placeholder="select pages">
                <option value="5" selected=selected>5 per page</option>
                <option value="10">10 per page</option>
                <option value="25">25 per page</option>
                <option value="50">50 per page</option>
      </b-select>-->
      <div class="column is-one-eight">
        <button
          class="button is-secondary download_button is-outlined"
          @click="reload"
        >
          Reload
        </button>
      </div>
      <!-- <div class="column" v-if="selectedOrders.length!=0">
        <button class="button is-secondary download_button" @click="downloadCSV">Download CSV</button>
      </div>
      <div class="column" v-if="selectedOrders.length!=0">
        <button class="button is-secondary download_button" @click="downloadDeliveryNotes">
          Download Delivery
          Notes
        </button>
      </div>

      <div class="column" v-if="selectedOrders.length!=0">
        <button class="button is-secondary download_button" @click="downloadProcurementList">
          Download Procurement
          List
        </button>
      </div>
      <div class="column" v-if="selectedOrders.length!=0">
        <b-field label="Change Statuses" horizontal>
          <b-select placeholder="Select Status" v-model="multipleUpdate.status">
            <option v-for="status in statuses" :value="status" :key="status">{{ status }}</option>
          </b-select>
          <button
            class="button is-primary is-outlined"
            @click="updateSelectedOrdersStatus"
          >Update Orders</button>
        </b-field>
      </div> -->
    </div>
    <div class="results-table">
      <b-table
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :data="orders"
        :bordered="true"
        title="Orders"
        :striped="true"
        :hoverable="true"
        :loading="isLoading"
        :mobile-cards="true"
        checkable
        :checked-rows.sync="selectedOrders"
      >
        <template slot-scope="props">
          <!-- <b-table-column
            field="status"
            label="Status"
            sortable
            centered
            v-if="showStatus"
          >
            <span
              class="tag is-success"
              v-if="['CANCELLED', 'PENDING'].indexOf(props.row.status) == -1"
              >{{ props.row.isCOD ? "COD" : props.row.status }}</span
            >
            <span class="tag is-light" v-else>{{
              props.row.status == "Created" ? "Not-Paid" : props.row.status
            }}</span>
            <b-tooltip
              label="Proof of Payment"
              class="is-secondary"
              v-if="props.row.pop"
            >
              <a
                class="button is-secondary is-outlined"
                :href="props.row.pop"
                target="_blank"
                style="margin:5px;"
              >
                <b-icon icon="receipt" size="is-small"></b-icon>
              </a>
            </b-tooltip>
          </b-table-column> -->

          <b-table-column field="customer" label="Customer Name">
            <!-- {{ props.row.requestor ? props.row.requestor.name : "" }} -->
            {{ props.row.userId }}

            <!-- <p style="font-weight:bolder; font-size:2em;">
            </p> -->
            <!-- {{ props.row.requestor ? props.row.requestor.mobileNumber : "" }} -->

            <!-- <b-collapse :open="false" aria-id="contentIdForA11y1">
              <b-button
                class="button is-info is-small"
                slot="trigger"
                aria-controls="contentIdForA11y1"
                icon-left="mouse"
              >Extra Details</b-button>
              <div class="notification">
                <div class="content">
                  <p>Sender Name :{{ props.row.sender_name }}</p>
                  <p>
                    Sender Email:
                    <a style="text-decoration: underline">{{ props.row.sender_email }}</a>
                  </p>

                </div>
              </div>
            </b-collapse> -->
          </b-table-column>
          <!-- <b-table-column field="customer" label="Customer Number">
            <a
              style="text-decoration: underline, ; "
              @click="openSendMessageModal(props.row.delivery)"
            >{{ props.row.delivery.mobile_number }}</a>
          </b-table-column> -->

          <!-- <b-table-column field="product" label="Requested Equipment">
            <span>{{
              props.row.equipmentType && props.row.equipmentType.name
                ? props.row.equipmentType.name
                : "Unspecified"
            }}</span>
          </b-table-column> -->

          <b-table-column field="address" label="Address">
            {{ props.row.address }} ha
          </b-table-column>

          <b-table-column field="products" label="Products" >{{
            props.row.products
          }}</b-table-column>

          <b-table-column field="amount" label="Amount" sortable>{{
            props.row.amount
          }}</b-table-column>

          <b-table-column field="status" label="Status" sortable>
            {{
              props.row.status
            }}
          </b-table-column>

          <b-table-column field="action" label="Action">
            <b-field label="Change Status">
              <b-select
                placeholder="Select Status"
                v-model="props.row.newStatus"
              >
                <option
                  v-for="status in statuses"
                  :value="status"
                  :key="status"
                  >{{ status }}</option
                >
              </b-select>
            </b-field>
            <b-field label>
              <b-tooltip label="Update Order" class="is-secondary">
                <button
                  class="button is-secondary is-outlined"
                  @click="setOrderStatus(props.row.id, props.row.newStatus)"
                  style="margin:5px;"
                >
                  <b-icon icon="update" size="is-small"></b-icon>
                </button>
              </b-tooltip>

              <!-- <b-tooltip label="Edit">
                <button
                  class="button is-primary"
                  @click="openEditOrderModal(props.row)"
                  style="margin:5px;"
                >
                  <b-icon icon="pencil" size="is-small"></b-icon>
                </button>
              </b-tooltip>

              <b-tooltip class="is-danger" label="Delete">
                <button
                  v-if="props.row.status=='Created' || props.row.status=='Cash-On-Delivery'"
                  class="button is-danger"
                  @click="confirmDeleteOrder(props.row)"
                  style="margin:5px;"
                >
                  <b-icon icon="delete" size="is-small"></b-icon>
                </button>
              </b-tooltip> -->
            </b-field>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>Nothing here.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import decode from "jwt-decode";
import {
  exportCSVFile,
  days,
  months,
  cleanStr,
  getSuburb,
  ls
} from "@/helpers";
import { mapGetters, mapActions } from "vuex";
import SendMessageModal from "./SendMessageModal";
// import EditOrderModal from "./EditOrderModal";
import QrcodeVue from "qrcode.vue";
import printJS from "print-js";

export default {
  name: "OrdersTable",
  props: [
    "data",
    "title",
    "isLoading",
    "showStatus",
    "showTotal",
    "hideDrivers"
  ],
  components: {
    QrcodeVue
  },
  data() {
    return {
      size: 200,
      value: "",
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 20,
      selectedOrders: [],
      multipleUpdate: {
        status: "",
        products: []
      },
      userTypeStatuses: {
        admin: [
          "Pending",
          "Cancelled",
          "Accepted",
          "Dispatched",
          "Delayed",
          "Delivered",
          "Returned"
        ],
        "provincial-manager": [
          "Accepted",
          "Dispatched",
          "Delayed",
          "Delivered",
          "Returned"
        ]
      },
      clearDriver: {
        name: "Select to unassign",
        mobileNumber: "",
        id: ""
      },
      driverFilter: ""
    };
  },

  computed: {
    ...mapGetters(["filters", "drivers", "users"]),
    statuses() {
      const { type } = decode(ls("token")).user;
      return this.userTypeStatuses[type];
    },
    orders() {
      return this.data.map(order => {
        order.selected = this.selectedOrderIds.indexOf(order.id) != -1;
        order.filter = "";
        return order;
      });
    },
    selectedOrderIds() {
      return this.selectedOrders.map(order => order.id);
    },
    Status() {
      return this.data.length > 0 ? this.data[0].status : "Created";
    },
    multipleUpdateAvailableStatuses() {
      return this.orderAvailableStatuses(this.Status);
    }
  },
  methods: {
    ...mapActions(["editOrder"]),
    driverName(driverId) {
      return this.drivers.filter(driver => driver.id == driverId);
    },
    printData(orderId) {
      return this.data.filter(order => order.id == orderId);
    },
    print(arg1, arg2) {
      console.log(this.printData());
      return printJS(arg1, arg2);
    },
    async assignDriver({ id, driver }) {
      console.log(driver);
      if (driver) {
        const loading = this.$loading.open();
        try {
          this.reload();
          await this.editOrder({ id, driverId: driver.id });
          loading.close();
          this.$toasted.global.success(`Order Assigned To ${driver.name}.`);
        } catch (e) {
          console.log(`Exception when assign order to driver, e: ${e}`);
        }
      } else {
        this.$toasted.global.error(`Select a driver first.`);
      }
    },
    openSendMessageModal(user) {
      this.$modal.open({
        component: SendMessageModal,
        parent: this,
        props: {
          user
        },
        events: {
          reload: () => {
            this.getBoxes();
          }
        }
      });
    },
    openEditOrderModal(order) {
      this.$modal.open({
        component: EditOrderModal,
        parent: this,
        props: {
          order
        }
      });
    },
    downloadProcurementList() {
      const orders = this.orders.filter(
        order => ["En-Route", "Paid"].indexOf(order.status) > -1
      );
      let productQuantity = {};

      orders.forEach(order => {
        order.products.forEach(product => {
          productQuantity[product.name] = productQuantity[product.name]
            ? productQuantity[product.name] + product.quantity
            : product.quantity;
        });
      });

      let items = Object.keys(productQuantity).map(productName => {
        return {
          product: productName,
          quantity: productQuantity[productName]
        };
      });

      const date = new Date(this.filters.fromDate);
      const month = months[date.getMonth()];
      const day = days[date.getDay()];
      const filename = `${day},${date.getDate()} ${month} ${date.getFullYear()} ${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}-Packing-Sheet`;

      exportCSVFile(
        {
          product: "Product",
          quantity: "Quantity"
        },
        items,
        filename
      );
    },
    orderAvailableStatuses(status) {
      let tmp = this.statuses;
      const index = tmp.indexOf(status);
      if (index == -1) return [];
      return tmp
        .slice(index + 1)
        .filter((value, index, self) => self.indexOf(value) === index);
    },
    async setOrderStatus(equipmentRequestId, status) {
      if (status && status != "") {
        const loading = this.$loading.open();
        try {
          await this.$store.dispatch("setEquipmentRequestStatus", {
            equipmentRequestId,
            changes: {
              status: status.toUpperCase()
            }
          });
          this.$toasted.global.success("Order Status Updated.");
          loading.close();
          this.reload();
        } catch (e) {
          loading.close();
          console.log(`Exception when setting order status,e: ${e}`);
          this.$toasted.global.error(
            "Failed to set new status for selected order."
          );
        }
      }
    },
    toggleOrderSelection(order) {
      order.selected = true;
      const orderAlreadyInSelected =
        this.selectedOrders.filter(
          selectedOrder => selectedOrder.id == order.id
        ).length > 0;
      this.selectedOrders = orderAlreadyInSelected
        ? this.selectedOrders.filter(
            selectedOrder => selectedOrder.id != order.id
          )
        : [...this.selectedOrders, order];
    },
    selectAllOrders() {
      this.selectedOrders = this.orders.map(order => {
        order.selected = true;
        return order;
      });
    },
    async downloadDeliveryNotes() {
      const loading = this.$loading.open();
      if (this.selectedOrders.length == 0)
        return this.$toasted.global.error("Atleast select something.");

      let orderIds = this.selectedOrders.map(order => order.id).reverse();
      try {
        await this.$store.dispatch("getDeliveryNotes", orderIds);
        loading.close();
        this.reload();
      } catch (e) {
        console.log(`Exception when downloading delivery notes`, e);
        this.$toasted.global.error("Failed to download delivery notes.");
        loading.close();
      }
    },
    downloadCSV() {
      if (this.selectedOrders.length == 0)
        return this.$toasted.global.error("Atleast select something.");

      const orders = [];
      this.selectedOrders.forEach(order => {
        const tmp = {
          customer: cleanStr(order.delivery.name),
          paid: order.isCOD
            ? "COD"
            : order.isPaypal
            ? "Paid-Paypal"
            : "Paid-Ecocash",
          status: order.status,
          mobile_number: cleanStr(order.delivery.mobile_number),
          address: cleanStr(order.delivery.address),
          suburb: cleanStr(
            order.delivery.suburb
              ? order.delivery.suburb
              : getSuburb(order.delivery.address)
          ),
          quantity: order.products[0].quantity,
          product: order.products[0].name, // the first product will be in line with the rest of the detail
          order_date: new Date(order.createdAt).toDateString(),
          delivery_date: new Date(order.delivery.date).toDateString(),
          delivery_note: cleanStr(order.delivery.notes),
          note: cleanStr(order.note),
          account_holder: order.account_holder ? "YES" : "NO"
        };

        orders.push(tmp);

        if (order.products.length > 1) {
          // if there are more than 1 products, add the rest as new lines
          for (let i = 1; i < order.products.length; i++) {
            const product = order.products[i];
            orders.push({
              customer: " ",
              paid: " ",
              status: " ",
              mobile_number: " ",
              address: " ",
              suburb: " ",
              quantity: product.quantity,
              product: product.name, // the first product will be in line with the rest of the detail
              order_date: " ",
              delivery_date: " ",
              delivery_note: " ",
              note: " ",
              account_holder: " "
            });
          }
        }
      });
      const date = new Date();
      const month = months[date.getMonth()];
      const day = days[date.getDay()];
      const filename = `${day},${date.getDate()} ${month} ${date.getFullYear()} ${date.getHours()}-${date.getMinutes()}-${date.getSeconds()} ${
        this.Status
      }-Orders`;

      exportCSVFile(
        {
          customer: "Customers",
          paid: "Paid/COD",
          status: "Status",
          mobile_number: "MobileNumber",
          address: "Address",
          suburb: "Suburb",
          quantity: "Quantity",
          product: "Product",
          order_date: "OrderDate",
          delivery_date: "DeliveryDate",
          delivery_note: "DeliveryNote",
          note: "OrderNote",
          account_holder: "AccountHolder"
        },
        orders,
        filename
      );
    },
    async updateSelectedOrdersStatus() {
      const orderIds = this.selectedOrders.map(order => order.id);
      console.log(orderIds);
      const { status } = this.multipleUpdate;
      const loading = this.$loading.open();
      try {
        //              await this.$store.dispatch('updateMultipleOrders', { orderIds, changes: { status } })
        loading.close();
        this.$toasted.global.success("Orders Updated.");
        this.selectedOrders = [];
        this.reload();
      } catch (e) {
        console.log(`Exception when updating multiple orders`, e);
        this.$toasted.global.error("Failed to update orders.");
        loading.close();
      }
    },
    confirmDeleteOrder(order) {
      this.$dialog.confirm({
        type: "is-danger",
        title: `Delete Order`,
        message:
          "Are you sure you want to delete this order? This action is NOT reversible.",
        confirmText: "Delete Order",
        onConfirm: () => this.deleteOrder(order.id)
      });
    },
    async deleteOrder(orderId) {
      const loading = this.$loading.open();
      try {
        await this.$store.dispatch("deleteOrder", orderId);
        loading.close();
        this.$toasted.global.success("Order Deleted");
        this.reload();
      } catch (e) {
        console.log(`Exception when deleting order, e: ${e}`);
        this.$toasted.global.error("Failed to delete that order.");
        loading.close();
        this.reload();
      }
    },
    reload() {
      this.selectedOrders = [];
      this.$emit("reloadOrders");
    },
    generateDeliveryNote(order) {
      this.$store.dispatch("getDeliveryNote", order);
    },
    setOrderDriverId(orderId, selectedDriver) {
      console.log(selectedDriver);
    }
  }
};
</script>

<style scoped>
.download_button {
  color: #fff;
  font-weight: bold;
}

.table_button {
  color: #fff;
  font-weight: bold;
}

.font_bold {
  font-weight: bold;
}

.hide {
  z-index: 3;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 500ms;
  visibility: hidden;
  opacity: 0;
}

.space {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Shop/OrdersTable.vue